import type { PropsWithChildren } from "react";
import AppModal from "./AppModal";

const WizardModal: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <AppModal className="flex flex-col sm:mx-auto medium:sm:min-h-[600px] tall:sm:min-h-[800px] sm:min-w-[600px] md:min-w-[700px] lg:min-w-[800px]">
      {children}
    </AppModal>
  );
};

export default WizardModal;
